import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';

// Translation for FocusedStatePageHeader default values
export const TranslateFocusedStatePageHeader = () => {
  return {
    homeTooltipLabel: useDsTranslateMessage({
      id: 'mcds.focusedStatePageHeader.home_tooltip_label',
      defaultMessage: 'Home',
    }),
    menuTooltipLabel: useDsTranslateMessage({
      id: 'mcds.focusedStatePageHeader.menu_tooltip_label',
      defaultMessage: 'Menu',
    }),
    backNavigationLabel: useDsTranslateMessage({
      id: 'mcds.focusedStatePageHeader.back_navigation_label',
      defaultMessage: 'Back',
    }),
    freddieIconAltText: useDsTranslateMessage({
      id: 'mcds.focusedStatePageHeader.freddie_icon_alt_text',
      defaultMessage: 'Home',
    }),
  };
};
